import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/Home.vue'


Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: resolve => require(['@/views/Home'], resolve),
  },
  {
    path: '/aboutme',
    name: 'aboutme',
    component: resolve => require(['@/views/aboutme'], resolve),
  }];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js